import styled from 'styled-components';

import { Dropdown } from '../../../../../components/Dropdown';
import { StyledDropdownButton } from '../../../../../components/Dropdown/styles';

export const StyledCategoryFilterContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const StyledCategoryFilterButton = styled(StyledDropdownButton)`
  width: 100%;
  justify-content: center;
`;

export const StyledCategoryFilterDropdown = styled(Dropdown)`
  width: 100%;
`;
